import React, { useCallback, useContext, useMemo } from "react";
import { PrimaryButton } from "../../../../components/button";
import { GlobalOverlayContext } from "../../../../components/overlay/context";
import { formatEther, getOption } from "../../../../utils/utils";
import { StakeContext } from "../context";
import ClaimRewardsModal from "../form/claim-rewards";
import Tile from "./tile";

interface IClaimRewardsTileProps { }

const ClaimRewardsTile: React.FunctionComponent<IClaimRewardsTileProps> = (
  props
) => {
  const { currentContract, stats } = useContext(StakeContext);
  const { setOverlay } = useContext(GlobalOverlayContext);

  const openClaimRewardsModal = useCallback(() => {
    setOverlay({
      children: (
        <ClaimRewardsModal onClose={() => setOverlay({ children: null })} />
      ),
      title: "Claim Rewards",
      onClose: () => Promise.resolve(),
    });
  }, [setOverlay, ClaimRewardsModal]);

  const hasRewards = useMemo(
    () =>
      currentContract
        .map((x) => x.walletInfo)
        .map((x) => x.rewards.full)
        .map((reward) => reward.gtn(0))
        .getOrElse(false),
    [currentContract]
  );

  return currentContract
    .map((x) => x.walletInfo)
    .map((x) => x.rewards.full)
    .fold(
      () => null,
      (rew) => (
        <Tile
          title="Your Rewards"
          cta={
            <></>
          }
        >
          $SKRT&nbsp;
          {formatEther(rew)}
        </Tile>
        // <Tile
        //   title="Your Rewards"
        //   cta={
        //     <PrimaryButton
        //       fullWidth
        //       onClick={openClaimRewardsModal}
        //       disabled={
        //         !hasRewards ||
        //         currentContract.map(({ active }) => !active).getOrElse(true)
        //       }
        //     >
        //       <strong>CLAIM</strong>
        //     </PrimaryButton>
        //   }
        // >
        //   $SKRT&nbsp;
        //   {formatEther(rew)}
        // </Tile>
      )
    );
};

export default ClaimRewardsTile;
